import React from "react";
import DashboardInterpretationsMonthly from "./DashboardInterpretationsMonthly";

const DashboardV2InterpretationsMonthly = ({ user, dateSelection }) => (
  <DashboardInterpretationsMonthly user={user} dateSelection={dateSelection} />
);

export default DashboardV2InterpretationsMonthly;
